import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { FormBuilder, FormGroup } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { SaveForm } from '@tokeet/tv3-platform'
import * as R from 'ramda'
import { Guest } from '@tv3/store/guest/guest.model'
import { AddTagsToGuest } from '@tv3/store/guest/guest.actions'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'
import { AddNewTags, LoadTags, selectTags } from '@tokeet/tv3-platform'

@Component({
  selector: 'app-manage-tags',
  host: { class: 'modal-content' },
  templateUrl: './manage-tags-dialog.component.html',
  styleUrls: ['./manage-tags-dialog.component.scss'],
})
export class ManageTagsDialogComponent extends Destroyable implements OnInit {
  form = this.fb.group({
    tags: [[]],
  })

  tags: string[]

  constructor(
    public dialogRef: MatDialogRef<ManageTagsDialogComponent>,
    private router: Router,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { guest: Guest },
    private store: Store<fromRoot.State>
  ) {
    super()
  }

  ngOnInit() {
    this.store.dispatch(LoadTags())

    this.form.patchValue({ tags: this.data.guest.tags || [] })

    this.store.pipe(select(selectTags('guest')), untilDestroy(this)).subscribe((tags) => {
      this.tags = this.processTags(tags)
    })
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const formValues = form.getRawValue()
    const tags = this.processTags(formValues.tags)
    const newTags = this.processTags(R.filter((tag: string) => (this.tags || []).indexOf(tag) < 0, tags))
    this.store.dispatch(AddTagsToGuest({ guest: this.data.guest, tags, newTags }))
    if (!R.isEmpty(newTags)) {
      this.store.dispatch(AddNewTags({ payload: { tags: newTags, type: 'guest' } }))
    }
    this.close()
  }

  addNewTag = (tag: string) => {
    return tag
  }

  private processTags(tags: string[]) {
    return R.map(R.pipe(R.when(R.is(Number), R.toString), R.toLower))(tags || [])
  }
}
